import React from 'react';
import styled from 'styled-components';
import { Color, Text } from '../../styles/common';

function Footer() {
  return (
    <Container>
      <Inner>
        Copyright&copy; 2022. 백승전. All rights reserved.
      </Inner>
    </Container>
  )
}

export default Footer;

const Container = styled.footer`
  width: 100%;
  position: fixed;
  bottom: 0;
  padding: 30px 0;
`

const Inner = styled.div`
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
  padding: 10px 0;
  font-size: ${ Text.SM };
  color: ${ Color. GRAY200 };
`